import Api from '../api';

let uri = '/api/ed/file'

let uriS3Upload = '/api/ed/upload/s3';
let uriS3Get = '/api/ed/get/s3';

export const uploadFile = (formData) => {
    return Api.getInstance().executeMultipart(uri, formData)
        .then((resp) => resp)
        .catch((error) => error);
 };

export const uploadFileS3 = (data) => {
    return Api.getInstance().executeMultipart(`${uriS3Upload}`, data)
        .then((resp) => resp)
        .catch((error) => error);
}

export const getFileS3 = (data) => {
    console.log(data);
    return Api.getInstance().executeQuery(uriS3Get, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const renameFile = (data) => {
    return Api.getInstance().executeMultipart(`${uri}/rename`, data)
        .then((resp) => resp)
        .catch((error) => error);
}

